import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CRODetailResult, CROFilters, CROSummaryResult } from './types';

export interface CRODetailRequestPayload {
  initiative: string;
  filters: CROFilters;
}

interface CRORequestState<T> {
  data: T | null;
  isLoading: boolean;
  error: string | null;
}

export interface CROState {
  summary: CRORequestState<CROSummaryResult>;
  detail: CRORequestState<CRODetailResult>;
}

const initialState: CROState = {
  summary: { data: null, isLoading: false, error: null },
  detail: { data: null, isLoading: false, error: null },
};

const croSlice = createSlice({
  name: 'cro',
  initialState,
  reducers: {
    fetchSummaryRequested(state, _action: PayloadAction<CROFilters>) {
      state.summary = { data: null, isLoading: true, error: null };
    },
    fetchSummarySucceeded(state, action: PayloadAction<CROSummaryResult>) {
      state.summary = { data: action.payload, isLoading: false, error: null };
    },
    fetchSummaryFailed(state, action: PayloadAction<string>) {
      state.summary = { data: null, isLoading: false, error: action.payload };
    },
    fetchDetailRequested(state, _action: PayloadAction<CRODetailRequestPayload>) {
      state.detail = { data: null, isLoading: true, error: null };
    },
    fetchDetailSucceeded(state, action: PayloadAction<CRODetailResult>) {
      state.detail = { data: action.payload, isLoading: false, error: null };
    },
    fetchDetailFailed(state, action: PayloadAction<string>) {
      state.detail = { data: null, isLoading: false, error: action.payload };
    },
  },
});

export const {
  fetchSummaryRequested,
  fetchSummarySucceeded,
  fetchSummaryFailed,
  fetchDetailRequested,
  fetchDetailSucceeded,
  fetchDetailFailed,
} = croSlice.actions;

export default croSlice.reducer;
